module.exports = __webpack_public_path__ + "media/images/athletes/2489-fd5c3f4fae8f34429ba1e8e2bd064993.png";